module.exports = __webpack_public_path__ + "img/s4.d8f7cd39.svg";